import { useQuery } from "@tanstack/react-query";
import api from "./api";

// Orari di default (originali) — usati come fallback e per i turni vecchi senza orario memorizzato
export const DEFAULT_ORARI = {
  mattina: { inizio: "07:00", fine: "14:00" },
  pomeriggio: { inizio: "14:00", fine: "20:00" },
  notte: { inizio: "20:00", fine: "07:00" },
  cucina: { inizio: "07:00", fine: "14:00" },
};

export const DEFAULT_HOURS = { mattina: 7, pomeriggio: 6, notte: 11, sera: 11, giorno: 6, not_mat: 18, mat_pom: 13 };

export const oreOrario = (inizio, fine) => {
  try {
    const [ah, am] = String(inizio).split(":").map(Number);
    const [bh, bm] = String(fine).split(":").map(Number);
    let s = ah * 60 + am;
    let e = bh * 60 + bm;
    if (e <= s) e += 24 * 60;
    return Math.round(((e - s) / 60) * 10) / 10;
  } catch {
    return 0;
  }
};

// Ore da una stringa "HH:MM-HH:MM"
export const oreDaStringa = (orario) => {
  if (!orario || !orario.includes("-")) return null;
  const [a, b] = orario.split("-");
  return oreOrario(a, b);
};

// Etichetta "07:00 - 14:00"
export const orarioLabel = (o) => (o ? `${o.inizio} - ${o.fine}${o.diversi ? " (varia per struttura)" : ""}` : "");
// Stringa compatta "07:00-14:00"
export const orarioStr = (o) => (o ? `${o.inizio}-${o.fine}` : "");

// Hook: legge gli orari configurati per la struttura (fallback ai default)
export function useOrariTurni(structureId) {
  const { data } = useQuery({
    queryKey: ["turni-orari", structureId || "all"],
    queryFn: async () => (await api.get("/turni/orari", { params: { structure_id: structureId || "all" } })).data,
  });
  return data || DEFAULT_ORARI;
}
